import Search from "../../../../../../../components/common/Search/Search"
import { Col, Input, Row } from "reactstrap"
import SuggestionComponent from "../../../../../../../components/common/SuggestionComponent/SuggestionComponent"
import DataTable from "react-data-table-component"
import SecondaryButton from "../../../../../../../components/common/SecondaryButton/SecondaryButton"

const KeywordsTable = () => {
  const data = [
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
    { keyword: "Headphones", bid: { placeholder: "$1.00", value: "$2.00" }, relevance: "High", searchVolume: "5,000", ctr: "1%" },
  ]

  const columns = [
    { name: "Keywords", selector: (row) => row.keyword, grow: 1 },
    {
      name: "Bid",
      cell: (row) => (
        <Row className="align-items-center g-0">
          <Col>
            <Input placeholder={row.bid.placeholder} />
          </Col>
          <Col>
            <SuggestionComponent text={row.bid.value} />
          </Col>
        </Row>
      ),
      grow: 2,
    },
    {
      name: "Relevance",
      selector: (row) => row.relevance,
      grow: 1,
      center: true,
    },
    {
      name: "Search Volume",
      selector: (row) => row.searchVolume,
      grow: 1,
      center: true,
    },
    {
      name: "CTR",
      selector: (row) => row.ctr,
      grow: 1,
      center: true,
    },
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
  }

  return (
    <section className="border">
      <div className="d-flex justify-content-between p-2">
        <div>
          <Search placeholder="Search" />
        </div>
        <div>
          <SecondaryButton name="Add Keywords" />
        </div>
      </div>

      <DataTable data={data} columns={columns} customStyles={customStyles} selectableRows />
    </section>
  )
}

export default KeywordsTable
